<template>
  <div :class="s.contentPublicity">    
    <img
      :src="require('../../images/ic_supervision_publicity1.png')"
      @click="gotoDetail(1)"
      :class="[s.slice, s.clickable]"
    />
    <div/>
    <img
      :src="require('../../images/ic_supervision_publicity2.png')"
      @click="gotoDetail(2)"
      :class="[s.slice, s.clickable]"
    />
    <div :class="[s.slice, s.block]">
      <h3>保护个人信息谨防网络诈骗</h3>
      <img
          :src="require('../../images/ic_publicity3.jpeg')"
          @click="gotoDetail(3)"
        />
    </div>
    <div/>
    <div :class="[s.slice, s.block]">
      <h3>汇聚金融力量共创美好生活</h3>
        <img
          :src="require('../../images/ic_publicity4.jpeg')"
          @click="gotoDetail(4)"
        />
    </div>
    <div :class="[s.slice, s.block]">
      <h3>金融消保在身边 保障权益防风险</h3>
      <img
          :src="require('../../images/ic_publicity5.jpeg')"
          @click="gotoDetail(5)"
        />
    </div>
  </div>
</template>

<script>
import { sendDataTrack } from '@/utils';

export default {
  name: 'ContentPublicity',
  computed: {
    s() {
      return this.$style;
    }
  },
  methods: {
    gotoDetail(type) {
      sendDataTrack('publicity', 'event', { type })
      this.$router.push(`/publicity/detail?type=${type}`);
    }
  }
};
</script>

<style scoped lang="less" module>
.contentPublicity {
  display: flex;
  flex-wrap: wrap;

  > div {
    width: 48px;
  }

  .slice {
    width: calc(50% - 24px);
    object-fit: cover;
  }

  .clickable {
    cursor: pointer;
  }

  .block {
    margin-top: 10px;

    h3 {
      font-size: 20px;
      color: #1669bc;
    }

    img {
      width: 100%;
      cursor: pointer;
    }
  }
}
</style>
